import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  primary: 'bg-primary bg-opacity-10 text-primary',
  purple: 'bg-purple bg-opacity-10 text-purple',
  success: 'bg-success bg-opacity-10 text-success',
  gold: 'bg-gold bg-opacity-10 text-gold',
  blue: 'bg-icon-focus text-primary',
  danger: 'bg-danger bg-opacity-10 text-danger'
}

const SHELL = 'w-full rounded-2xl border border-border-lines p-4'

export default function StatCard({ icon: Icon = UIcons.UilChartLine, label, value, suffix, trend, tone = 'primary', loading = false, compareLabel = 'vs Apr 14 - May 14' }) {
  const iconTone = TONES[tone] || TONES.primary
  const hasTrend = trend !== undefined && trend !== null
  const isPositive = trend >= 0

  // Placeholder mirrors the loaded layout so the grid doesn't reflow when data lands.
  if (loading) {
    return (
      <div className={`${SHELL} animate-pulse`} aria-busy="true">
        <div className="flex items-start justify-between gap-2">
          <div className="h-3 w-2/3 rounded bg-background" />
          <div className="w-9 h-9 rounded-full bg-background shrink-0" />
        </div>
        <div className="h-5 w-1/2 rounded bg-background mt-3" />
      </div>
    )
  }

  return (
    <div className={SHELL}>
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm text-secondary truncate">{label}</p>
        <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${iconTone}`}>
          <Icon size={18} />
        </div>
      </div>

      <div className="flex items-baseline gap-1.5 mt-2">
        <p className="text-xl font-bold text-dark-blue">{value}</p>
        {suffix && <span className="text-xs text-secondary">{suffix}</span>}
      </div>

      {
        hasTrend && (
          <div className="flex items-center gap-1.5 mt-2">
            <span className={`inline-flex items-center gap-0.5 text-xs font-medium px-1.5 py-0.5 rounded ${isPositive ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'}`}>
              {isPositive ? <UIcons.UilArrowUp size={11} /> : <UIcons.UilArrowDown size={11} />}
              {Math.abs(trend)}%
            </span>
            <span className="text-xs text-secondary whitespace-nowrap">{compareLabel}</span>
          </div>
        )
      }
    </div>
  )
}
